import { mockComponentRenderProp } from 'bloko/common/setupMockComponents';

const { DownPlacement, DownLayer } = jest.requireActual('bloko/blocks/drop/Down/index.js');
export { DownPlacement, DownLayer };

export default mockComponentRenderProp('DropDown', null, {
    withChildren: true,
});
